import { useEffect, useState } from "react";
import debounce from "lodash/debounce";
import { MAGIC_TEXT_DEBOUNCE_FOR_SR } from "../constants";
export const useNoOptionsMessage = (elementRef, currentDerivedOptions, message, isLoading) => {
    const hasNoOptionsMessage = (currentDerivedOptions && currentDerivedOptions.length === 0 && !isLoading) ||
        currentDerivedOptions === undefined ||
        (currentDerivedOptions.length === 1 && currentDerivedOptions[0].groupItems?.length === 0);
    const [screenReaderContent, setScreenReaderContent] = useState("");
    useEffect(() => {
        const element = elementRef.current;
        if (element === null) {
            return;
        }
        if (process.env.NODE_ENV === "test") {
            setScreenReaderContent(element.textContent || "");
            return;
        }
        const srContent = debounce(() => {
            setScreenReaderContent(element.textContent || "");
        }, MAGIC_TEXT_DEBOUNCE_FOR_SR);
        const observerScreenReader = new MutationObserver(srContent);
        observerScreenReader.observe(element, { subtree: true, childList: true, characterData: true });
        srContent();
        return () => {
            observerScreenReader.disconnect();
        };
    }, [elementRef, isLoading]);
    return { hasNoOptionsMessage, screenReaderContent };
};
